var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / EU") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-EU",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "#043CAE",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.942809,15.7238576 L14.6666667,16.6666667 L14.942809,17.6094757 L14,17.3333333 L13.057191,17.6094757 L13.3333333,16.6666667 L13.057191,15.7238576 L14,16 L14.942809,15.7238576 Z M11.6094757,14.8306937 L11.3333333,15.7735027 L11.6094757,16.7163117 L10.6666667,16.4401694 L9.72385763,16.7163117 L10,15.7735027 L9.72385763,14.8306937 L10.6666667,15.106836 L11.6094757,14.8306937 Z M18.2761424,14.8306937 L18,15.7735027 L18.2761424,16.7163117 L17.3333333,16.4401694 L16.3905243,16.7163117 L16.6666667,15.7735027 L16.3905243,14.8306937 L17.3333333,15.106836 L18.2761424,14.8306937 Z M20.7163117,12.3905243 L20.4401694,13.3333333 L20.7163117,14.2761424 L19.7735027,14 L18.8306937,14.2761424 L19.106836,13.3333333 L18.8306937,12.3905243 L19.7735027,12.6666667 L20.7163117,12.3905243 Z M9.16930635,12.3905243 L8.89316397,13.3333333 L9.16930635,14.2761424 L8.22649731,14 L7.28368827,14.2761424 L7.55983064,13.3333333 L7.28368827,12.3905243 L8.22649731,12.6666667 L9.16930635,12.3905243 Z M21.6094757,9.05719096 L21.3333333,10 L21.6094757,10.942809 L20.6666667,10.6666667 L19.7238576,10.942809 L20,10 L19.7238576,9.05719096 L20.6666667,9.33333333 L21.6094757,9.05719096 Z M8.27614237,9.05719096 L8,10 L8.27614237,10.942809 L7.33333333,10.6666667 L6.39052429,10.942809 L6.66666667,10 L6.39052429,9.05719096 L7.33333333,9.33333333 L8.27614237,9.05719096 Z M20.7163117,5.72385763 L20.4401694,6.66666667 L20.7163117,7.60947571 L19.7735027,7.33333333 L18.8306937,7.60947571 L19.106836,6.66666667 L18.8306937,5.72385763 L19.7735027,6 L20.7163117,5.72385763 Z M9.16930635,5.72385763 L8.89316397,6.66666667 L9.16930635,7.60947571 L8.22649731,7.33333333 L7.28368827,7.60947571 L7.55983064,6.66666667 L7.28368827,5.72385763 L8.22649731,6 L9.16930635,5.72385763 Z M18.2761424,3.28368827 L18,4.22649731 L18.2761424,5.16930635 L17.3333333,4.89316397 L16.3905243,5.16930635 L16.6666667,4.22649731 L16.3905243,3.28368827 L17.3333333,3.55983064 L18.2761424,3.28368827 Z M11.6094757,3.28368827 L11.3333333,4.22649731 L11.6094757,5.16930635 L10.6666667,4.89316397 L9.72385763,5.16930635 L10,4.22649731 L9.72385763,3.28368827 L10.6666667,3.55983064 L11.6094757,3.28368827 Z M14.942809,2.39052429 L14.6666667,3.33333333 L14.942809,4.27614237 L14,4 L13.057191,4.27614237 L13.3333333,3.33333333 L13.057191,2.39052429 L14,2.66666667 L14.942809,2.39052429 Z",
    id: "Star-2",
    fill: "#FFD429",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEu);
export default __webpack_public_path__ + "static/media/EU.5d885901ca7b07dcd30dd2690dcc9b25.svg";
export { ForwardRef as ReactComponent };